import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Icon from 'Core/Components/Icon';
import Divider from 'Core/Components/Divider';
import Fieldset from 'RLX/Forms/Fieldset';
import { updateContentSection } from 'RLX/State/Content/ContentActions';

class ContentController extends React.Component {
  constructor (props) {
    super(props);
    this.state = { previewing: false };
    this.getFields = this.getFields.bind(this);
    this.getContent = this.getContent.bind(this);
    this.getPreview = this.getPreview.bind(this);
    this.applyUpdate = this.applyUpdate.bind(this);
    this.showPreview = this.showPreview.bind(this);
    this.hidePreview = this.hidePreview.bind(this);
    this.renderHeader = this.renderHeader.bind(this);
    this.removeSection = this.removeSection.bind(this);
  }

  static getInitialShape () {
    throw new ReferenceError(`ContentController subclass has no .getInitialShape() override`);
  }

  showPreview () {
    this.setState({ previewing: true });
  }

  hidePreview () {
    this.setState({ previewing: false });
  }

  applyUpdate (handler) {
    const { content, contentIndex, page } = this.props;
    return (newValue) => {
      const replacement = handler(newValue, content);
      updateContentSection(page.id, replacement);
    };
  }

  getBlockName () {
    return null;
  }

  getClassName () {
    return null;
  }

  getPreview () {
    return null;
  }

  getFields () {
    return [];
  }

  shouldDisplayPreviewInline () {
    return false;
  }

  removeSection () {
    const { onContentRemove, content } = this.props;
    if (typeof onContentRemove !== 'function')
      throw new TypeError(`ContentController.removeSection: "onContentRemove" is not a function. (${onContentRemove})`);
    if (!confirm('Are you sure you want to delete this content section?')) return;
    onContentRemove(content);
  }

  renderHeader () {
    const { previewing } = this.state;
    const { hidePreview, showPreview } = this;
    const { content } = this.props;
    const { type } = content;
    const name = this.getBlockName() !== null ? this.getBlockName() : type;
    const shouldDisplayPreviewInline = this.shouldDisplayPreviewInline();
    const hasPreviewMode = this.getPreview() !== null;
    const switchViews = (previewing ? hidePreview : showPreview);
    return (
      <div className="ContentEditor-Header">
        <h1>{name}</h1>
        {!hasPreviewMode || shouldDisplayPreviewInline
          ? null
          : (
            <button className="subtle" onClick={switchViews}>
              <Icon fa={previewing ? 'paint-brush' : 'eye'} style={{marginRight: '10px'}} />
              {previewing ? 'Switch To Editor' : 'Switch To Preview'}
            </button>
          )
        }
        <button className="negative" onClick={this.removeSection}><Icon fa="trash left"/> Delete Section</button>
      </div>
    );
  }

  getContent () {
    return null;
  }

  render () {
    const Content = this.getContent;
    const Header = this.renderHeader;
    const { previewing } = this.state;
    const fields = this.getFields();
    const preview = this.getPreview();
    const className = this.getClassName();
    const shouldDisplayPreviewInline = this.shouldDisplayPreviewInline();
    return (
      <div className={'ContentEditor' + (className ? ' ' + className : '')}>
        <Header />
        <Content />
        {shouldDisplayPreviewInline
          ? (
            <Fragment>
              <div className="ContentEditor-Preview">{preview}</div>
              <Fieldset fields={fields} />
            </Fragment>
          ) : !preview || !previewing
            ? <Fieldset fields={fields} />
            : <div className="ContentEditor-Preview">{preview}</div>
        }
      </div>
    );
  }
};

export default ContentController;



// WEBPACK FOOTER //
// ./client/RLX/Controllers/ContentController.jsx